unit View.Apagar.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils;

type
  TFViewApagarList = class(TForm)
    btNew: TButton;
    ApagarDataset: TXDataWebDataSet;
    ApagarDatasetid: TIntegerField;
    ApagarDatasetaliado_id: TIntegerField;
    ApagarDatasetdata_base_id: TIntegerField;
    ApagarDatasetmodalidade_id: TIntegerField;
    ApagarDatasetcompra_id: TIntegerField;
    ApagarDatasetfornecedor_id: TIntegerField;
    ApagarDatasetplano_contas_id: TIntegerField;
    ApagarDatasetdocumento: TStringField;
    ApagarDatasetparcela: TStringField;
    ApagarDatasetvalor: TFloatField;
    ApagarDatasetsaldo: TFloatField;
    ApagarDatasetpago: TFloatField;
    ApagarDatasetemissao: TDateTimeField;
    ApagarDatasetvencimento: TDateTimeField;
    ApagarDatasetpagamento: TDateTimeField;
    ApagarDatasetcodigo_interno: TIntegerField;
    ApagarDatasetexcluido: TBooleanField;
    ApagarDatasetinclusao: TDateTimeField;
    ApagarDatasetalteracao: TDateTimeField;
    ApagarDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewApagarList: TFViewApagarList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewApagarList }

procedure TFViewApagarList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewApagarList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewApagarList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewApagarList, AElementID, Result, @AfterCreate);
end;

procedure TFViewApagarList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewApagarList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewApagarList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewApagarList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ApagarDataset.Connection.Model.DefaultSchema.FindEntityType(ApagarDataset.EntitySetName),
      ApagarDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewApagarList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('apagar', 'active');
  TUtils.SetValorDicionarioClasses('pagamentos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_pagamentos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    ApagarDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewApagarList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.apagar.list.pagination.info');
  btNew := TButton.Create('view.apagar.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.apagar.list.table');
  cbPageSize := TComboBox.Create('view.apagar.list.cbPageSize');
  edSearch := TEdit.Create('view.apagar.list.search');
  lcPaginator := TListControl.Create('view.apagar.list.pagination');
  ApagarDataset := TXDataWebDataSet.Create(Self);
  ApagarDatasetid := TIntegerField.Create(Self);
  ApagarDatasetaliado_id := TIntegerField.Create(Self);
  ApagarDatasetdata_base_id := TIntegerField.Create(Self);
  ApagarDatasetmodalidade_id := TIntegerField.Create(Self);
  ApagarDatasetcompra_id := TIntegerField.Create(Self);
  ApagarDatasetfornecedor_id := TIntegerField.Create(Self);
  ApagarDatasetplano_contas_id := TIntegerField.Create(Self);
  ApagarDatasetdocumento := TStringField.Create(Self);
  ApagarDatasetparcela := TStringField.Create(Self);
  ApagarDatasetvalor := TFloatField.Create(Self);
  ApagarDatasetsaldo := TFloatField.Create(Self);
  ApagarDatasetpago := TFloatField.Create(Self);
  ApagarDatasetemissao := TDateTimeField.Create(Self);
  ApagarDatasetvencimento := TDateTimeField.Create(Self);
  ApagarDatasetpagamento := TDateTimeField.Create(Self);
  ApagarDatasetcodigo_interno := TIntegerField.Create(Self);
  ApagarDatasetexcluido := TBooleanField.Create(Self);
  ApagarDatasetinclusao := TDateTimeField.Create(Self);
  ApagarDatasetalteracao := TDateTimeField.Create(Self);
  ApagarDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  ApagarDataset.BeforeLoadDFMValues;
  ApagarDatasetid.BeforeLoadDFMValues;
  ApagarDatasetaliado_id.BeforeLoadDFMValues;
  ApagarDatasetdata_base_id.BeforeLoadDFMValues;
  ApagarDatasetmodalidade_id.BeforeLoadDFMValues;
  ApagarDatasetcompra_id.BeforeLoadDFMValues;
  ApagarDatasetfornecedor_id.BeforeLoadDFMValues;
  ApagarDatasetplano_contas_id.BeforeLoadDFMValues;
  ApagarDatasetdocumento.BeforeLoadDFMValues;
  ApagarDatasetparcela.BeforeLoadDFMValues;
  ApagarDatasetvalor.BeforeLoadDFMValues;
  ApagarDatasetsaldo.BeforeLoadDFMValues;
  ApagarDatasetpago.BeforeLoadDFMValues;
  ApagarDatasetemissao.BeforeLoadDFMValues;
  ApagarDatasetvencimento.BeforeLoadDFMValues;
  ApagarDatasetpagamento.BeforeLoadDFMValues;
  ApagarDatasetcodigo_interno.BeforeLoadDFMValues;
  ApagarDatasetexcluido.BeforeLoadDFMValues;
  ApagarDatasetinclusao.BeforeLoadDFMValues;
  ApagarDatasetalteracao.BeforeLoadDFMValues;
  ApagarDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewApagarList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_id';
      Title := 'modalidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'compra_id';
      Title := 'compra_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'fornecedor_id';
      Title := 'fornecedor_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_contas_id';
      Title := 'plano_contas_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'documento';
      Title := 'documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'parcela';
      Title := 'parcela';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'saldo';
      Title := 'saldo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'pago';
      Title := 'pago';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'emissao';
      Title := 'emissao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'vencimento';
      Title := 'vencimento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'pagamento';
      Title := 'pagamento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    ApagarDataset.SetParentComponent(Self);
    ApagarDataset.Name := 'ApagarDataset';
    ApagarDataset.EntitySetName := 'Apagar';
    ApagarDataset.Connection := DMConnection.ApiConnection;
    ApagarDataset.Left := 72;
    ApagarDataset.Top := 144;
    ApagarDatasetid.SetParentComponent(ApagarDataset);
    ApagarDatasetid.Name := 'ApagarDatasetid';
    ApagarDatasetid.FieldName := 'id';
    ApagarDatasetid.Required := True;
    ApagarDatasetaliado_id.SetParentComponent(ApagarDataset);
    ApagarDatasetaliado_id.Name := 'ApagarDatasetaliado_id';
    ApagarDatasetaliado_id.FieldName := 'aliado_id';
    ApagarDatasetaliado_id.Required := True;
    ApagarDatasetdata_base_id.SetParentComponent(ApagarDataset);
    ApagarDatasetdata_base_id.Name := 'ApagarDatasetdata_base_id';
    ApagarDatasetdata_base_id.FieldName := 'data_base_id';
    ApagarDatasetdata_base_id.Required := True;
    ApagarDatasetmodalidade_id.SetParentComponent(ApagarDataset);
    ApagarDatasetmodalidade_id.Name := 'ApagarDatasetmodalidade_id';
    ApagarDatasetmodalidade_id.FieldName := 'modalidade_id';
    ApagarDatasetmodalidade_id.Required := True;
    ApagarDatasetcompra_id.SetParentComponent(ApagarDataset);
    ApagarDatasetcompra_id.Name := 'ApagarDatasetcompra_id';
    ApagarDatasetcompra_id.FieldName := 'compra_id';
    ApagarDatasetfornecedor_id.SetParentComponent(ApagarDataset);
    ApagarDatasetfornecedor_id.Name := 'ApagarDatasetfornecedor_id';
    ApagarDatasetfornecedor_id.FieldName := 'fornecedor_id';
    ApagarDatasetplano_contas_id.SetParentComponent(ApagarDataset);
    ApagarDatasetplano_contas_id.Name := 'ApagarDatasetplano_contas_id';
    ApagarDatasetplano_contas_id.FieldName := 'plano_contas_id';
    ApagarDatasetdocumento.SetParentComponent(ApagarDataset);
    ApagarDatasetdocumento.Name := 'ApagarDatasetdocumento';
    ApagarDatasetdocumento.FieldName := 'documento';
    ApagarDatasetdocumento.Size := 255;
    ApagarDatasetparcela.SetParentComponent(ApagarDataset);
    ApagarDatasetparcela.Name := 'ApagarDatasetparcela';
    ApagarDatasetparcela.FieldName := 'parcela';
    ApagarDatasetparcela.Size := 255;
    ApagarDatasetvalor.SetParentComponent(ApagarDataset);
    ApagarDatasetvalor.Name := 'ApagarDatasetvalor';
    ApagarDatasetvalor.FieldName := 'valor';
    ApagarDatasetvalor.Required := True;
    ApagarDatasetsaldo.SetParentComponent(ApagarDataset);
    ApagarDatasetsaldo.Name := 'ApagarDatasetsaldo';
    ApagarDatasetsaldo.FieldName := 'saldo';
    ApagarDatasetpago.SetParentComponent(ApagarDataset);
    ApagarDatasetpago.Name := 'ApagarDatasetpago';
    ApagarDatasetpago.FieldName := 'pago';
    ApagarDatasetemissao.SetParentComponent(ApagarDataset);
    ApagarDatasetemissao.Name := 'ApagarDatasetemissao';
    ApagarDatasetemissao.FieldName := 'emissao';
    ApagarDatasetvencimento.SetParentComponent(ApagarDataset);
    ApagarDatasetvencimento.Name := 'ApagarDatasetvencimento';
    ApagarDatasetvencimento.FieldName := 'vencimento';
    ApagarDatasetvencimento.Required := True;
    ApagarDatasetpagamento.SetParentComponent(ApagarDataset);
    ApagarDatasetpagamento.Name := 'ApagarDatasetpagamento';
    ApagarDatasetpagamento.FieldName := 'pagamento';
    ApagarDatasetcodigo_interno.SetParentComponent(ApagarDataset);
    ApagarDatasetcodigo_interno.Name := 'ApagarDatasetcodigo_interno';
    ApagarDatasetcodigo_interno.FieldName := 'codigo_interno';
    ApagarDatasetcodigo_interno.Required := True;
    ApagarDatasetexcluido.SetParentComponent(ApagarDataset);
    ApagarDatasetexcluido.Name := 'ApagarDatasetexcluido';
    ApagarDatasetexcluido.FieldName := 'excluido';
    ApagarDatasetinclusao.SetParentComponent(ApagarDataset);
    ApagarDatasetinclusao.Name := 'ApagarDatasetinclusao';
    ApagarDatasetinclusao.FieldName := 'inclusao';
    ApagarDatasetalteracao.SetParentComponent(ApagarDataset);
    ApagarDatasetalteracao.Name := 'ApagarDatasetalteracao';
    ApagarDatasetalteracao.FieldName := 'alteracao';
    ApagarDatasetexclusao.SetParentComponent(ApagarDataset);
    ApagarDatasetexclusao.Name := 'ApagarDatasetexclusao';
    ApagarDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ApagarDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    ApagarDataset.AfterLoadDFMValues;
    ApagarDatasetid.AfterLoadDFMValues;
    ApagarDatasetaliado_id.AfterLoadDFMValues;
    ApagarDatasetdata_base_id.AfterLoadDFMValues;
    ApagarDatasetmodalidade_id.AfterLoadDFMValues;
    ApagarDatasetcompra_id.AfterLoadDFMValues;
    ApagarDatasetfornecedor_id.AfterLoadDFMValues;
    ApagarDatasetplano_contas_id.AfterLoadDFMValues;
    ApagarDatasetdocumento.AfterLoadDFMValues;
    ApagarDatasetparcela.AfterLoadDFMValues;
    ApagarDatasetvalor.AfterLoadDFMValues;
    ApagarDatasetsaldo.AfterLoadDFMValues;
    ApagarDatasetpago.AfterLoadDFMValues;
    ApagarDatasetemissao.AfterLoadDFMValues;
    ApagarDatasetvencimento.AfterLoadDFMValues;
    ApagarDatasetpagamento.AfterLoadDFMValues;
    ApagarDatasetcodigo_interno.AfterLoadDFMValues;
    ApagarDatasetexcluido.AfterLoadDFMValues;
    ApagarDatasetinclusao.AfterLoadDFMValues;
    ApagarDatasetalteracao.AfterLoadDFMValues;
    ApagarDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
